import { render, staticRenderFns } from "./PTextField.vue?vue&type=template&id=49b720c7&"
import script from "./PTextField.vue?vue&type=script&lang=js&"
export * from "./PTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports